import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import ActionTypes from '../../../../../constants/ActionTypes';
import { createSearchParamsManhattanAction } from '../../../searchParams/actions';
import { setBundleSelectedDataAction } from '../../bundleData/actions';
import { setAdditionalDevicesPopupVisibilityAction } from './actions';


export const setStbNumberMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  if (action.type.includes(ActionTypes.MANHATTAN.FTTH.ADDITIONAL_DEVICES.SET_STB_NUMBER)) {
    const bundleData = store.getState().manhattan.bundleData;
    bundleData.selectedProducts[0].stb.quantity = action.payload.numberOfDevices;
    next(createSearchParamsManhattanAction({ stbNumber: action.payload.numberOfDevices }));
    next(setAdditionalDevicesPopupVisibilityAction(false));
    next(setBundleSelectedDataAction(bundleData.selectedProducts));
  }
};

export const additionalDevicesMiddleware = [setStbNumberMiddleware];
